export default [
  {
    vendorid: "01",
    name: "Harsh Dedhia",
    email: "harsh@gmail.com",
    category: "Catering",
    status: "Approved",
    commissiontype: "Fixed",
    discount: "850",
    vendorshopstatus: "Enabled",
    dateadded: "8/7/2021",
    currency: "INR"
  },
  {
    vendorid: "02",
    name: "Sumit Jaiswal",
    email: "sumit@gmail.com",
    category: "Catering",
    status: "Pending",
    commissiontype: "Percentage",
    discount: "10",
    vendorshopstatus: "Enabled",
    dateadded: "8/7/2021",
    currency: "INR"
  },
  {
    vendorid: "03",
    name: "Mohnish Thandassery",
    email: "mohnish@gmail.com",
    category: "Catering",
    status: "Disapproved",
    commissiontype: "Perentage",
    discount: "17",
    vendorshopstatus: "Disabled",
    dateadded: "8/7/2021",
    currency: "INR"
  }
];
